import { register, getPrefix, getCookie } from '../../../Utils'

const ProfessionalityConsent = el => {
  const prefix = getPrefix(el)

  const cookieName = 'professionality_consent'
  const acceptButton = el.querySelector(`.${prefix}accept-button`)

  const clickConsent = e => {
    e.preventDefault()

    el.classList.remove(`${prefix}is--visible`)
    const expiryDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1))
    document.cookie = `${cookieName}=true; expires=${expiryDate}; path=/; SameSite=lax; Secure`
  }

  if (!getCookie(cookieName)) {
    el.classList.add(`${prefix}is--visible`)
    acceptButton.addEventListener('click', clickConsent)
  }
}

register('ProfessionalityConsent', ProfessionalityConsent)
